import { bandToColor, getCellScore, normalizeMatrixConfig, scoreToBand } from "../../utils/riskMatrixLogic";

// Use the same cells and category scope as the heatmap, including custom matrices.
export function riskBandSeries(grid, cells, rawConfig, categories = []) {
  const config = normalizeMatrixConfig(rawConfig);
  const buckets = new Map(config.band_thresholds.map((band) => [band.name, {
    label: band.name, value: 0, color: bandToColor({ band: band.name, bandColors: config.band_colors }),
  }]));
  for (const [impact, row] of Object.entries(grid || {})) {
    if (!Number.isInteger(Number(impact)) || Number(impact) < 1 || Number(impact) > config.matrix_size) continue;
    for (const [likelihood, risks] of Object.entries(row || {})) {
      if (!Number.isInteger(Number(likelihood)) || Number(likelihood) < 1 || Number(likelihood) > config.matrix_size) continue;
      if (!Array.isArray(risks)) continue;
      const value = risks.filter((risk) => !categories.length || categories.includes(risk.category)).length;
      const cell = cells?.[impact]?.[likelihood];
      const band = cell?.band || scoreToBand({
        score: getCellScore({ scoringMode: config.scoring_mode, cellScores: config.cell_scores, lik: likelihood, imp: impact }),
        bandThresholds: config.band_thresholds,
      });
      if (!buckets.has(band)) buckets.set(band, { label: band, value: 0, color: cell?.color || "#64748b" });
      const bucket = buckets.get(band);
      bucket.value += value;
      if (cell?.color) bucket.color = cell.color;
    }
  }
  return [...buckets.values()];
}

export function validateHeatmap(data) {
  if (!data?.grid || Array.isArray(data.grid) || typeof data.grid !== "object") throw new Error("Missing heatmap grid");
  const size = Number(data.matrix_config?.matrix_size) || 5;
  for (let impact = 1; impact <= size; impact += 1) {
    for (let likelihood = 1; likelihood <= size; likelihood += 1) {
      if (!Array.isArray(data.grid[impact]?.[likelihood])) throw new Error("Incomplete heatmap grid");
    }
  }
  return data;
}

export const chartScopeKey = (user, token) => JSON.stringify([
  token, user?.tenant_id, user?.org_id, user?.id, user?.username,
  user?.role, user?.access_profile, user?.is_admin_equivalent, user?.effective_access,
]);

const STATUS_COLORS = { OPEN: "#0284c7", IN_PROGRESS: "#0d9488", BLOCKED: "#f59e0b", COMPLETED: "#16a34a", CLOSED: "#16a34a", CANCELLED: "#94a3b8" };
export function actionStatusSeries(data) {
  return (data?.status_breakdown || []).map((item) => ({
    label: item.label || item.value,
    value: item.count,
    color: STATUS_COLORS[String(item.value).toUpperCase()] || "#64748b",
  }));
}

export function controlAttentionSeries(data) {
  return [
    { label: "Ineffective", value: data.ineffective_controls, color: "#dc2626" },
    { label: "Overdue reviews", value: data.overdue_reviews, color: "#ea580c" },
    { label: "Overdue tests", value: data.overdue_tests, color: "#d97706" },
    { label: "Unrated", value: data.unrated_controls, color: "#64748b" },
    { label: "Missing evidence", value: data.missing_evidence, color: "#0891b2" },
  ];
}
